import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import {
  BtnBold,
  BtnItalic,
  createButton,
  Editor,
  EditorProvider,
  Toolbar,
} from "react-simple-wysiwyg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListUl,
  faListOl,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
} from "@fortawesome/free-solid-svg-icons";
import { SessionContext } from "../SessionProvider";

const CreateSyllabusModel = (props) => {
  console.log("props == ",props)
   const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const navigate = useNavigate();
  const [classOptions, setClassOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [syllabusData, setSyllabusData] = useState({
    class_id: "",
    section_id: "",
    subject_id: "",
    session_id: selectedSessionId,
    isactive: "",
    description: "",
  });

  console.log('syllabusData22=>',syllabusData)
  const BtnAlignCenter = createButton(
    "Align center",
    <FontAwesomeIcon icon={faAlignCenter} />,
    "justifyCenter"
  );
  const BtnAlignLeft = createButton(
    "Align left",
    <FontAwesomeIcon icon={faAlignLeft} />,
    "justifyLeft"
  );
  const BtnAlignRight = createButton(
    "Align right",
    <FontAwesomeIcon icon={faAlignRight} />,
    "justifyRight"
  );
  const BtnUl = createButton(
    "Unordered List",
    <FontAwesomeIcon icon={faListUl} />,
    "insertUnorderedList"
  );
  const BtnLi = createButton(
    "Ordered List",
    <FontAwesomeIcon icon={faListOl} />,
    "insertOrderedList"
  );

  useEffect(() => {
    const fetchAllClasses = async () => {
      try {
        const result = await schoolApi.getActiveClassRecords();
        const classes = result?.result?.map((item) => ({
          value: item.id,
          label: item.class_name,
        }));
        setClassOptions(classes);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    fetchAllClasses();
  }, []);

  useEffect(() => {
    const fetchAllSubjects = async () => {
      try {
        const subjects = await schoolApi.fetchSubject();
        if (subjects.success) {
          const subjectOptions = subjects.result.map((sub) => ({
            value: sub.id,
            label: sub.name,
          }));
          setSubjectOptions(subjectOptions);
        }
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    fetchAllSubjects();
  }, []);

  useEffect(() => {
    const fetchAllSessions = async () => {
      try {
        const sessions = await schoolApi.fetchSessions();
        if (sessions.success) {
          const sessionOptions = sessions.result.map((sess) => ({
            value: sess.id,
            label: sess.year,
          }));
          setSessionOptions(sessionOptions);
        }
      } catch (error) {
        console.error("Error fetching sessions:", error);
      }
    };

    fetchAllSessions();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (props.syllabusData) {
        console.log("props if")
        setSyllabusData({
          class_id: props.syllabusData.class_id,
          section_id: props.syllabusData.section_id,
          subject_id: props.syllabusData.subject_id,
          session_id: props.syllabusData.session_id ? props.syllabusData.session_id : selectedSessionId,
          isactive: props.syllabusData.isactive,
          description: props.syllabusData.description,
        });

        if (props.syllabusData.class_id) {
          const result = await schoolApi.getSectionRecordById(
            props?.syllabusData?.class_id
          );
          if (result.success) {
            const sections = result.record
              .filter(
                (item) =>
                  item.isactive && item.class_id === props.syllabusData.class_id
              )
              .map((item) => ({
                value: item.id,
                label: item.name,
              }));
            setSectionOptions(sections);
          }
        }
      }else{
        console.log("props else")
        setSyllabusData({
          class_id: "",
          section_id: "",
          subject_id: "",
          session_id: selectedSessionId,
          isactive: "",
          description: "",
        });
      }
    };

    fetchData();
  }, [props.syllabusData,selectedSessionId]);

  const handleChange = async (e) => {
    setSyllabusData({ ...syllabusData, [e.target.name]: e.target.value });
    if (e.target.name === "class_id") {
      const result = await schoolApi.getSectionRecordById(e.target.value);
      let ar = [];
      result &&
        result?.record?.map((item) => {
          if (item.isactive != null && item.isactive == true) {
            if (item.class_id === e.target.value) {
              var obj = {};
              obj.value = item.id;
              obj.label = item.name;
              ar.push(obj);
            }
          }
        });
      setSectionOptions(ar);
      setSyllabusData((prevState) => ({
        ...prevState,
        section_id: "",
      }));
    }
  };

  const handleEditorChange = (value) => {
    setSyllabusData((prev) => ({ ...prev, description: value }));
  };


  const handleSubmit = async () => {
    console.log("handleSubmit == ",syllabusData)
    const { class_id, section_id, subject_id, session_id, isactive } =
      syllabusData;

      console.log('syllabusData@@!@=>',syllabusData)

    if (!class_id || !section_id || !subject_id || !session_id || !isactive) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      let result;
      if (props.syllabusData) {
        result = await schoolApi.updateSyllabus(
          props.syllabusData.id,
          syllabusData
        );
      } else {
        result = await schoolApi.createSyllabus(syllabusData);
      }

      if (result.success) {
        toast.success(
          `Syllabus ${props.syllabusData ? "updated" : "created"} successfully`
        );
        props.handleCloseModal();
        props.fetchAllSyllabus();
        setSyllabusData({
          class_id: "",
          section_id: "",
          subject_id: "",
          session_id: selectedSessionId,
          isactive: "",
          description: "",
        })
        navigate("/syllabuslist");
      } else {
        toast.error(result.message || "An error occurred");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while processing your request");
    }
  };

  return (
    <Modal
      show={props.modalShow}
      centered
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      // onHide={props.handleCloseModal}
      onHide={() => {
        props.handleCloseModal();
        if (props.btnName === "Save") {
          setSyllabusData({
            class_id: "",
            section_id: "",
            subject_id: "",
            session_id: selectedSessionId,
            isactive: "",
            description: "",
          });
        }
        else{
          setSyllabusData({
            class_id: props.syllabusData.class_id,
            section_id: props.syllabusData.section_id,
            subject_id: props.syllabusData.subject_id,
            session_id: props.syllabusData.session_id ? props.syllabusData.session_id : selectedSessionId,
            isactive: props.syllabusData.isactive,
            description: props.syllabusData.description,
          })
          props.fetchAllSyllabus();

        }
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {props.syllabusData ? "Update Syllabus" : "Create Syllabus"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body  style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Form className="mt-3">
          <Row>
            <Col lg={6}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Class</Form.Label>
                <Form.Select
                  name="class_id"
                  onChange={handleChange}
                  value={syllabusData.class_id}
                  required
                >
                  <option value="">-- Select Class --</option>
                  {classOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={6}>
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Subject</Form.Label>
                <Form.Select
                  name="subject_id"
                  onChange={handleChange}
                  value={syllabusData.subject_id}
                  required
                >
                  <option value="">-- Select Subject --</option>
                  {subjectOptions.map((sub) => (
                    <option key={sub.value} value={sub.value}>
                      {sub.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Section</Form.Label>
                <Form.Select
                  name="section_id"
                  onChange={handleChange}
                  value={syllabusData.section_id}
                  required
                >
                  <option value="">-- Select Section --</option>
                  {sectionOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label className="form-view-label">Session</Form.Label>
                <Form.Select
                  name="session_id"
                  onChange={handleChange}
                  value={syllabusData.session_id}
                  required
                >
                  <option value="">-- Select Session --</option>
                  {sessionOptions.map((res) => (
                    <option key={res.value} value={res.value}>
                      {res.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="mt-3">
              <Form.Group className="mx-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  required
                  name="isactive"
                  value={syllabusData.isactive}
                  onChange={handleChange}
                >
                  <option value="">-- Select Status --</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={12} className="mt-3">
              <EditorProvider className="resizable-editor">
                <Editor
                  name="description"
                  placeholder="Enter description"
                  value={syllabusData.description}
                  onChange={(e) => handleEditorChange(e.target.value)}
                >
                  <Toolbar>
                    <BtnBold />
                    <BtnItalic />
                    <BtnAlignLeft />
                    <BtnAlignCenter />
                    <BtnAlignRight />
                    <BtnLi />
                    <BtnUl />
                  </Toolbar>
                </Editor>
              </EditorProvider>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleSubmit}>
          {props.btnName}
        </Button>
        <Button variant="light" 
        // onClick={props.handleCloseModal}
        
        onClick={() => {
          props.handleCloseModal();
          
          if (props.btnName === "Save") {
            setSyllabusData({
              class_id: "",
              section_id: "",
              subject_id: "",
              session_id: selectedSessionId,
              isactive: "",
              description: "",
            });
          }
          else{
            setSyllabusData({
              class_id: props.syllabusData.class_id,
              section_id: props.syllabusData.section_id,
              subject_id: props.syllabusData.subject_id,
              session_id: props.syllabusData.session_id ? props.syllabusData.session_id : selectedSessionId,
              isactive: props.syllabusData.isactive,
              description: props.syllabusData.description,
            })
            props.fetchAllSyllabus();

          }

        }}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateSyllabusModel;

// import React, { useContext, useEffect, useState } from "react";
// import { Button, Col, Modal, Row, Form } from "react-bootstrap";
// import schoolApi from "../../api/schoolApi";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import "../../App.css";
// import {
//   BtnBold,
//   BtnItalic,
//   createButton,
//   Editor,
//   EditorProvider,
//   Toolbar,
// } from "react-simple-wysiwyg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faListUl,
//   faListOl,
//   faAlignLeft,
//   faAlignRight,
//   faAlignCenter,
// } from "@fortawesome/free-solid-svg-icons";
// import { SessionContext } from "../SessionProvider";

// const CreateSyllabusModel = (props) => {
//    const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
//   const navigate = useNavigate();
//   const [classOptions, setClassOptions] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);
//   const [sectionOptions, setSectionOptions] = useState([]);
//   const [sessionOptions, setSessionOptions] = useState([]);
//   const [syllabusData, setSyllabusData] = useState({
//     class_id: "",
//     section_id: "",
//     subject_id: "",
//     session_id: selectedSessionId,
//     isactive: "",
//     description: "",
//   });

//   console.log('syllabusData22=>',syllabusData)
//   const BtnAlignCenter = createButton(
//     "Align center",
//     <FontAwesomeIcon icon={faAlignCenter} />,
//     "justifyCenter"
//   );
//   const BtnAlignLeft = createButton(
//     "Align left",
//     <FontAwesomeIcon icon={faAlignLeft} />,
//     "justifyLeft"
//   );
//   const BtnAlignRight = createButton(
//     "Align right",
//     <FontAwesomeIcon icon={faAlignRight} />,
//     "justifyRight"
//   );
//   const BtnUl = createButton(
//     "Unordered List",
//     <FontAwesomeIcon icon={faListUl} />,
//     "insertUnorderedList"
//   );
//   const BtnLi = createButton(
//     "Ordered List",
//     <FontAwesomeIcon icon={faListOl} />,
//     "insertOrderedList"
//   );

//   useEffect(() => {
//     const fetchAllClasses = async () => {
//       try {
//         const result = await schoolApi.getActiveClassRecords();
//         const classes = result?.result?.map((item) => ({
//           value: item.id,
//           label: item.class_name,
//         }));
//         setClassOptions(classes);
//       } catch (error) {
//         console.error("Error fetching classes:", error);
//       }
//     };

//     fetchAllClasses();
//   }, []);

//   useEffect(() => {
//     const fetchAllSubjects = async () => {
//       try {
//         const subjects = await schoolApi.fetchSubject();
//         if (subjects.success) {
//           const subjectOptions = subjects.result.map((sub) => ({
//             value: sub.id,
//             label: sub.name,
//           }));
//           setSubjectOptions(subjectOptions);
//         }
//       } catch (error) {
//         console.error("Error fetching subjects:", error);
//       }
//     };

//     fetchAllSubjects();
//   }, []);

//   useEffect(() => {
//     const fetchAllSessions = async () => {
//       try {
//         const sessions = await schoolApi.fetchSessions();
//         if (sessions.success) {
//           const sessionOptions = sessions.result.map((sess) => ({
//             value: sess.id,
//             label: sess.year,
//           }));
//           setSessionOptions(sessionOptions);
//         }
//       } catch (error) {
//         console.error("Error fetching sessions:", error);
//       }
//     };

//     fetchAllSessions();
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       if (props.syllabusData) {
//         setSyllabusData({
//           class_id: props.syllabusData.class_id,
//           section_id: props.syllabusData.section_id,
//           subject_id: props.syllabusData.subject_id,
//           session_id: props.syllabusData.session_id,
//           isactive: props.syllabusData.isactive,
//           description: props.syllabusData.description,
//         });

//         if (props.syllabusData.class_id) {
//           const result = await schoolApi.getSectionRecordById(
//             props?.syllabusData?.class_id
//           );
//           if (result.success) {
//             const sections = result.record
//               .filter(
//                 (item) =>
//                   item.isactive && item.class_id === props.syllabusData.class_id
//               )
//               .map((item) => ({
//                 value: item.id,
//                 label: item.name,
//               }));
//             setSectionOptions(sections);
//           }
//         }
//       }else{
//         setSyllabusData({
//           class_id: "",
//           section_id: "",
//           subject_id: "",
//           session_id: selectedSessionId,
//           isactive: "",
//           description: "",
//         });
//       }
//     };

//     fetchData();
//   }, [props.syllabusData]);

//   const handleChange = async (e) => {
//     setSyllabusData({ ...syllabusData, [e.target.name]: e.target.value });
//     if (e.target.name === "class_id") {
//       const result = await schoolApi.getSectionRecordById(e.target.value);
//       let ar = [];
//       result &&
//         result?.record?.map((item) => {
//           if (item.isactive != null && item.isactive == true) {
//             if (item.class_id === e.target.value) {
//               var obj = {};
//               obj.value = item.id;
//               obj.label = item.name;
//               ar.push(obj);
//             }
//           }
//         });
//       setSectionOptions(ar);
//       setSyllabusData((prevState) => ({
//         ...prevState,
//         section_id: "",
//       }));
//     }
//   };

//   const handleEditorChange = (value) => {
//     setSyllabusData((prev) => ({ ...prev, description: value }));
//   };

//   const handleSubmit = async () => {
//     const { class_id, section_id, subject_id, session_id, isactive } =
//       syllabusData;

//       console.log('syllabusData@@!@=>',syllabusData)

//     if (!class_id || !section_id || !subject_id || !session_id || !isactive) {
//       toast.error("Please fill all required fields");
//       return;
//     }

//     try {
//       let result;
//       if (props.syllabusData) {
//         result = await schoolApi.updateSyllabus(
//           props.syllabusData.id,
//           syllabusData
//         );
//       } else {
//         result = await schoolApi.createSyllabus(syllabusData);
//       }

//       if (result.success) {
//         toast.success(
//           `Syllabus ${props.syllabusData ? "updated" : "created"} successfully`
//         );
//         props.handleCloseModal();
//         props.fetchAllSyllabus();
//         navigate("/syllabuslist");
//       } else {
//         toast.error(result.message || "An error occurred");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("An error occurred while processing your request");
//     }
//   };

//   return (
//     <Modal
//       show={props.modalShow}
//       centered
//       backdrop="static"
//       aria-labelledby="contained-modal-title-vcenter"
//       onHide={props.handleCloseModal}
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>
//           {props.syllabusData ? "Update Syllabus" : "Create Syllabus"}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form className="mt-3">
//           <Row>
//             <Col lg={6}>
//               <Form.Group className="mx-3">
//                 <Form.Label className="form-view-label">Class</Form.Label>
//                 <Form.Select
//                   name="class_id"
//                   onChange={handleChange}
//                   value={syllabusData.class_id}
//                   required
//                 >
//                   <option value="">-- Select Class --</option>
//                   {classOptions.map((res) => (
//                     <option key={res.value} value={res.value}>
//                       {res.label}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col lg={6}>
//               <Form.Group className="mx-3">
//                 <Form.Label className="form-view-label">Subject</Form.Label>
//                 <Form.Select
//                   name="subject_id"
//                   onChange={handleChange}
//                   value={syllabusData.subject_id}
//                   required
//                 >
//                   <option value="">-- Select Subject --</option>
//                   {subjectOptions.map((sub) => (
//                     <option key={sub.value} value={sub.value}>
//                       {sub.label}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg={6} className="mt-3">
//               <Form.Group className="mx-3">
//                 <Form.Label className="form-view-label">Section</Form.Label>
//                 <Form.Select
//                   name="section_id"
//                   onChange={handleChange}
//                   value={syllabusData.section_id}
//                   required
//                 >
//                   <option value="">-- Select Section --</option>
//                   {sectionOptions.map((res) => (
//                     <option key={res.value} value={res.value}>
//                       {res.label}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col lg={6} className="mt-3">
//               <Form.Group className="mx-3">
//                 <Form.Label className="form-view-label">Session</Form.Label>
//                 <Form.Select
//                   name="session_id"
//                   onChange={handleChange}
//                   value={syllabusData.session_id || selectedSessionId}
//                   required
//                 >
//                   <option value="">-- Select Session --</option>
//                   {sessionOptions.map((res) => (
//                     <option key={res.value} value={res.value}>
//                       {res.label}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg={6} className="mt-3">
//               <Form.Group className="mx-3">
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select
//                   required
//                   name="isactive"
//                   value={syllabusData.isactive}
//                   onChange={handleChange}
//                 >
//                   <option value="">-- Select Status --</option>
//                   <option value="Active">Active</option>
//                   <option value="Inactive">Inactive</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//           <Row>
//             <Col lg={12} className="mt-3">
//               <EditorProvider className="resizable-editor">
//                 <Editor
//                   name="description"
//                   placeholder="Enter description"
//                   value={syllabusData.description}
//                   onChange={(e) => handleEditorChange(e.target.value)}
//                 >
//                   <Toolbar>
//                     <BtnBold />
//                     <BtnItalic />
//                     <BtnAlignLeft />
//                     <BtnAlignCenter />
//                     <BtnAlignRight />
//                     <BtnLi />
//                     <BtnUl />
//                   </Toolbar>
//                 </Editor>
//               </EditorProvider>
//             </Col>
//           </Row>
//         </Form>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="success" onClick={handleSubmit}>
//           {props.btnName}
//         </Button>
//         <Button variant="light" onClick={props.handleCloseModal}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default CreateSyllabusModel;
